export default "__VITE_ASSET__f97ZnRVb__"